import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propBool, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import ProffitSearchLandingPageCtaButton from '../../Parts/ProffitSearchLandingPageCtaButton';
const ProffitSearchLandingPageKeyVisualCta = (props) => {
    const { className, isEndTrial, plan, showFormModal } = props;
    return (_jsxs("div", Object.assign({ className: clsx('proffit_search_landing_page_key_visual_cta', className) }, { children: [_jsxs("div", Object.assign({ className: 'cta_text' }, { children: ["PROFFIT SEARCH\u306F\u3001\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u306B\u5411\u3051\u305F\u3001", _jsx("br", {}), "\u30B9\u30E9\u30A4\u30C9\u691C\u7D22\u30FB\u8CC7\u6599\u4F5C\u6210\u652F\u63F4\u30C4\u30FC\u30EB\u3067\u3059\u3002"] })), _jsx(ProffitSearchLandingPageCtaButton, { className: 'cta_button', isEndTrial: isEndTrial, plan: plan, showFormModal: showFormModal, trialText: 'まずは無料で使ってみる' })] })));
};
ProffitSearchLandingPageKeyVisualCta.propTypes = {
    className: propStr(),
    isEndTrial: propBool().isRequired,
    plan: propStr(),
    showFormModal: propFunc().isRequired,
};
ProffitSearchLandingPageKeyVisualCta.defaultProps = {
    className: '',
    plan: undefined,
};
export default ProffitSearchLandingPageKeyVisualCta;
